/* @flow*/

const route = (state: string = 'DonationInProgress', action: any) => {
  switch (action.type) {
    case 'CHANGE_ROUTE':
      return action.route;
    default:
      return state;
  }
};

export default route;



/** WEBPACK FOOTER **
 ** ./src/reducers/route.js
 **/